/*
 * @Author: bbqin
 * @Date: 2023-04-20 10:36:54
 * @LastEditTime: 2023-04-20 11:19:30
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\TransferTable\optimizedResize.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

// setTimeout
// (function () {

//     window.addEventListener("resize", resizeThrottler, false);

//     var resizeTimeout;
//     function resizeThrottler() {
//         // ignore resize events as long as an actualResizeHandler execution is in the queue
//         if (!resizeTimeout) {
//             resizeTimeout = setTimeout(function () {
//                 resizeTimeout = null;
//                 actualResizeHandler();

//                 // The actualResizeHandler will execute at a rate of 15fps
//             }, 66);
//         }
//     }

//     function actualResizeHandler() {
//       // handle the resize event
//       ...
//     }

// }());

// requestAnimationFrame
// const optimizedResize = (function () {

//     var callbacks = [],
//         running = false;

//     // fired on resize event
//     function resize() {

//         if (!running) {
//             running = true;

//             if (window.requestAnimationFrame) {
//                 window.requestAnimationFrame(runCallbacks);
//             } else {
//                 setTimeout(runCallbacks, 66);
//             }
//         }

//     }

//     // run the actual callbacks
//     function runCallbacks() {

//         callbacks.forEach(function (callback) {
//             callback();
//         });

//         running = false;
//     }

//     // adds callback to loop
//     function addCallback(callback) {

//         if (callback) {
//             callbacks.push(callback);
//         }

//     }

//     return {
//         // public method to add additional callback
//         add: function (callback) {
//             if (!callbacks.length) {
//                 window.addEventListener('resize', resize);
//             }
//             addCallback(callback);
//         },
//     };
// }());

// requestAnimationFrame + customEvent
const optimizedResize = function (eventName = 'optimizedResize') {
    var throttle = function (type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function () {
            if (running) { return; }
            running = true;
            requestAnimationFrame(function () {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("resize", eventName);

    return throttle;
};

// handle event
// window.addEventListener("optimizedResize", function () {
//     console.log("Resource conscious resize callback!");
// });

export default optimizedResize;